var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFmhAccreditation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 10C14.4477 10 14 10.4477 14 11C14 11.5523 14.4477 12 15 12H17C17.5523 12 18 11.5523 18 11C18 10.4477 17.5523 10 17 10H15Z",
    fill: "#00182F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 15C14 14.4477 14.4477 14 15 14H17C17.5523 14 18 14.4477 18 15C18 15.5523 17.5523 16 17 16H15C14.4477 16 14 15.5523 14 15Z",
    fill: "#00182F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 11C6 10.4477 6.44772 10 7 10H11C11.5523 10 12 10.4477 12 11V15C12 15.5523 11.5523 16 11 16H7C6.44772 16 6 15.5523 6 15V11ZM8 14V12H10V14H8Z",
    fill: "#00182F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 3C10 3.55228 10.4477 4 11 4V6H4C2.89543 6 2 6.89543 2 8V18C2 19.1046 2.89543 20 4 20H20C21.1046 20 22 19.1046 22 18V8C22 6.89543 21.1046 6 20 6H13V4C13.5523 4 14 3.55228 14 3C14 2.44772 13.5523 2 13 2H11C10.4477 2 10 2.44772 10 3ZM4 18V8H20V18H4Z",
    fill: "#00182F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFmhAccreditation);
export default __webpack_public_path__ + "static/media/fmh-accreditation.a547e9af898dc5b68d93e015b3f0e973.svg";
export { ForwardRef as ReactComponent };